/**
 * Word Labyrinth — the ladder lookups (specs/labyrinth-mode.md §4.1).
 *
 * The `LABYRINTH` tunables themselves live in `src/game/config.ts` beside `PAIRS`, `MAZE` and
 * `WAGON`, where every other mode's block lives. They were parked here while that file was being
 * edited by the Word Wagon build; only these three readers stayed behind.
 */
import { LABYRINTH } from '@/game/config';

export { LABYRINTH };

/** Ladder lookups. The last rung repeats forever, like the Pairs and Maze ladders. */
function rung(round: number, len: number): number {
  return Math.min(Math.max(1, Math.floor(round)), len) - 1;
}

export function gridFor(round: number): [number, number] {
  return LABYRINTH.grids[rung(round, LABYRINTH.grids.length)];
}

export function pathCellsFor(round: number): [number, number] {
  return LABYRINTH.pathCells[rung(round, LABYRINTH.pathCells.length)];
}

export function bendsFor(round: number): number {
  return LABYRINTH.bends[rung(round, LABYRINTH.bends.length)];
}

export function forksFor(round: number): number {
  return LABYRINTH.forks[rung(round, LABYRINTH.forks.length)];
}

export function timeForRound(round: number): number {
  return LABYRINTH.timeMs[rung(round, LABYRINTH.timeMs.length)];
}
